// extracted by mini-css-extract-plugin
export default {"control":"Control_control__nni-L","button":"Control_button__Zzh8H"};